/* eslint-disable  @typescript-eslint/no-explicit-any */

/**
 * Список страниц, где будут использованы фильтры
 * */
export var ETargetPage;
/**
 * Список доступных полей
 */

(function (ETargetPage) {
  ETargetPage[ETargetPage["valuation"] = 0] = "valuation";
  ETargetPage[ETargetPage["valuationResults"] = 1] = "valuationResults";
  ETargetPage[ETargetPage["newBuilding"] = 2] = "newBuilding";
  ETargetPage[ETargetPage["realtorPromo"] = 3] = "realtorPromo";
  ETargetPage[ETargetPage["valuationAgentResults"] = 4] = "valuationAgentResults";
  ETargetPage[ETargetPage["valuationForAgentCalculatorPage"] = 5] = "valuationForAgentCalculatorPage";
})(ETargetPage || (ETargetPage = {}));

export var EFields;
/**
 * Интерфейсы пропсов отдельных фильтров, приходящих в виджет из места использования
 * */

(function (EFields) {
  EFields["flatNumber"] = "flatNumber";
  EFields["roomsCount"] = "roomsCount";
  EFields["area"] = "area";
  EFields["address"] = "address";
  EFields["estimationTarget"] = "estimationTarget";
  EFields["landArea"] = "landArea";
  EFields["houseArea"] = "houseArea";
})(EFields || (EFields = {}));